import { create } from 'zustand';

interface GroupCollapseState {
  collapsedStates: Record<string, boolean>;
  toggleCollapsed: (key: string, value: string) => void;
}

export const useGroupCollapse = create<GroupCollapseState>((set) => ({
  collapsedStates: {},

  toggleCollapsed: (key: string, value: string) => {
    const groupKey = `${key}:${value}`;
    set((state) => ({
      collapsedStates: {
        ...state.collapsedStates,
        [groupKey]: !state.collapsedStates[groupKey],
      },
    }));
  },
}));
